import { Building2, Wallet } from "lucide-react";
import { PAYMENT_MODEL } from "@constants/panel/common";

// The two payout models a brand chooses between at setup. `value` is what goes
// back to the API as `payment_model`; the copy is the brand-facing wording for
// the same models Ops sees in its own dropdowns.
export const PAYMENT_MODEL_CARDS = [
    {
        value      : PAYMENT_MODEL.MANAGED_PAYOUT,
        icon       : Wallet,
        title      : "Managed payout",
        description: "Nook Pay collects payment from you and disburses to your publishers on your behalf."
    },
    {
        value      : PAYMENT_MODEL.SELF_PAYOUT,
        icon       : Building2,
        title      : "Self payout",
        description: "You pay your publishers directly. Nook Pay tracks earnings and records your payment reference."
    }
];
